

import { useSelector, useDispatch } from "react-redux";
import Page404 from "../../../../components/Page404/Page403";
import { selectUserData } from "../../../../features/userSlice";
import { CheckPermissions } from "../../../../logic/Admin/Permissions/CheckPermission/CheckPermissions";
import LandingPageExperience from "../../../../components/Paid Traffic/Methodology/LPExperience/LandingPageExperience";
import { useEffect } from "react";
import { resetStateOfLP } from "../../../../features/landingPageExperienceSlice";

const LandingPageExperienceScreen = () => {
  const response = useSelector(selectUserData);
  const dispatch = useDispatch();
  const hasViewLandingPageExperienceTypesPermission = CheckPermissions(
    response?.data?.products?.paid_traffic,
    "plan_campaign_ppc",
    "view_lp_experience_overview"
  );

   //--Cleanup on unmount
  useEffect(() => {
    return () => {
      dispatch(resetStateOfLP());
    };
  }, [dispatch]);

  return (
    <>
      {hasViewLandingPageExperienceTypesPermission ? (
        <>
          <LandingPageExperience />
        </>
      ) : (
        <Page404 />
      )}
    </>
  );
};

export default LandingPageExperienceScreen;